<div class="container-fluid ml-n2">

  <!-- Confirm to Register keyless access immobilizer modal  -->
  <b-modal v-model="modalconfirmtostartkeylessaccessimmobilizerregistrationregKeylessImbType3" size="lg"
    header-bg-variant="secondary" header-text-variant="light" no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_confirmation')}}
      </div>
    </template>
    <template v-slot:default>
      <div class="text-left w-auto m-4">
        <div>
          <b>
            <div v-html="AddUnderline($t('imb.register_key_less_immobilizer_begin_keyless_imb_reg'))"> </div>
          </b>
        </div>
        <div>
          <b>{{$t('imb.common_press_ok_or_cancel')}}</b>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button variant="outline-primary"
          v-on:click="cancelButtonClick()">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button variant="primary" class="ml-4" v-on:click="registerKeyLessImbOkButtonClick()">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Process is on going -->
  <b-modal v-model="modalprocessisgoingonregKeylessImbType3" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')" hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('imb.common_executing')}}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-3 mb-4">
        <processing-view :processing="modelUpdateProcessing" class="update-processing-view"></processing-view>
      </div>
      <div class="text-center w-auto m-2">
        <div class="col-md-12" v-html="imbStatusInfo.error_message">
        </div>
        <div class="col-md-12">
          {{$t('imb.common_please_wait')}}
        </div>
      </div>
    </template>
  </b-modal>

  <!-- Confirm to Execute Keyless Access CM/Imb Registration? modal  -->
  <b-modal v-model="modalconfirmtoexecutekeylessaccessCMregistrationregKeylessImbType3" size="lg"
    header-bg-variant="secondary" header-text-variant="light" no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_confirmation')}}
      </div>
    </template>
    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3" v-html="imbStatusInfo.error_message">
        </div>
        <div class="text-center w-100">
          {{$t('imb.common_press_ok')}}
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" class="ml-2 mr-2" v-on:click="registrationOkButtonClick()">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>


  <!-- The proper Access Key(s) should be confirmed modal  -->
  <b-modal v-model="modaltheproperaccesskeysshouldbeconfirmedregKeylessImbType3" size="lg"
    header-bg-variant="secondary" header-text-variant="light" no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')"
    hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_confirmation')}}
      </div>
    </template>
    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3"
          v-html="$t('imb.register_key_less_immobilizer_owner_confrmed')">
        </div>
        <div class="text-center w-100 mt-3"
          v-html="$t('imb.register_key_less_immobilizer_prep_all_access_key_prev_reg')">
        </div>
        <div class="text-center w-100" v-html="imbStatusInfo.error_message">
        </div>
      </div>
    </template>
  </b-modal>


  <b-modal v-model="modalcheckingownerregKeylessImbType3" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')" hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_confirmation')}}
      </div>
    </template>
    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3"
          v-html="$t('imb.register_key_less_immobilizer_owner_confrmed')">
        </div>
        <div class="text-center w-100 mt-3"
          v-html="$t('imb.register_key_less_immobilizer_prep_1_access_key_reg_prev_off_igni')">
        </div>
      </div>
    </template>
  </b-modal>


  <b-modal v-model="modalaccessKeyregisteringregKeylessImbType3" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_confirmation')}}
      </div>
    </template>
    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3"
          v-html="$t('imb.register_key_less_immobilizer_access_key_registation')">
        </div>
        <div class="text-center w-100 mt-3"
          v-html="$t('imb.register_key_less_immobilizer_access_key_close_push_button')">
        </div>
      </div>
      <div>
        <div class="text-center w-100" v-html="imbStatusInfo.error_message">
        </div>
        <div class="text-center w-100">
          {{$t('imb.register_key_less_immobilizer_when_completed_press_quit')}}
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" class="ml-2 mr-2" v-on:click="accessKeyQuitButtonClick()">
          {{ $t('imb.common_quit') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- VD9 -->
  <b-modal v-model="modalaccessKeyregisterlimitregKeylessImbType3" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_confirmation')}}
      </div>
    </template>
    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3" v-html="$t('imb.common_num_reg_keys_type3',[7])">
        </div>
        <div class="text-center w-100 mt-3" v-html="$t('imb.register_key_less_immobilizer_num_reg_access_key_max')">
        </div>
        <div class="text-center w-100">
          {{$t('imb.common_press_ok')}}
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" class="ml-2 mr-2" v-on:click="accessKeyOkButtonClick()">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <b-modal v-model="modalignitiononregKeylessImbType3" size="lg" header-bg-variant="secondary" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')" hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_confirmation')}}
      </div>
    </template>
    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3" v-html="imbStatusInfo.error_message">
        </div>
      </div>
    </template>
  </b-modal>

  <!-- modal success keyless access immobilizer registration completed  -->
  <b-modal v-model="modalsuccessregKeylessImbType3" size="lg" header-bg-variant="success" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.common_title_success') }}
      </div>
    </template>

    <template v-slot:default>
      <div>
        <div v-if="isNorthAmerica" class="text-center w-100 mt-3"
          v-html="$t('imb.register_key_less_immobilizer_imb_reg_ended_north_america')"></div>
        <div v-else class="text-center w-100 mt-3" v-html="$t('imb.register_key_less_immobilizer_imb_reg_ended')"></div>
        <div class="text-center w-100">{{$t('imb.common_press_ok')}}</div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" v-on:click="successOkButtonClick()"
          class="ml-2 mr-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>


  <!-- Error modal  -->
  <b-modal v-model="modalerrfailedregKeylessImbType3" size="lg" header-bg-variant="danger" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{$t('message.common_title_error')}}
      </div>
    </template>

    <template v-slot:default>
      <div v-if="!isCausesAndActionDialog(imbStatusInfo.error_code)">
        <div class="text-center w-100 mt-3" v-html="imbStatusInfo.error_message">
        </div>
      </div>
      <div v-else>
        <div class="col-12 text-left row mt-1">
          <div class="col-3 text-right">{{ $t('message.label_repro_error_code') }}:</div>
          <div class="col-9">{{ imbStatusInfo.error_code }}</div>
        </div>
        <div class="col-12 text-left row mt-1">
          <div class="col-3 text-right">{{ $t('message.label_repro_error_cause') }}:</div>
          <div class="col-9" v-html="imbStatusInfo.error_cause_message"></div>
        </div>
        <div class="col-12 text-left row mt-1">
          <div class="col-3 text-right">{{ $t('message.label_repro_error_action') }}:</div>
          <div class="col-9" v-html="imbStatusInfo.error_action_message"></div>
        </div>
      </div>
      <div>
        <div class="text-center w-100 mt-2">
          {{ $t('imb.common_press_ok') }}
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" v-on:click="onErrorKeylessOkButtonClick()" class="ml-2 mr-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

</div>